"use strict";
/**
 * Created on 10 01 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NumberRange_1 = require("../model/math/NumberRange");

var utils_1 = require("../utils");

var DataObjectConverter_1 = require("./DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link NumberRange}. </p>
 *
 * @author JMe
 */


var NumberRangeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(NumberRangeConverter, _DataObjectConverter_);

  function NumberRangeConverter() {
    _classCallCheck(this, NumberRangeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberRangeConverter).apply(this, arguments));
  }

  _createClass(NumberRangeConverter, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        minimum: source.minimum,
        maximum: source.maximum
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new NumberRange_1.NumberRange(conversions.asObjectOpt(source, 'minimum', function (v) {
        return utils_1.Utils.asNumber(v);
      }), conversions.asObjectOpt(source, 'maximum', function (v) {
        return utils_1.Utils.asNumber(v);
      }));
    }
  }]);

  return NumberRangeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.NumberRangeConverter = NumberRangeConverter;